import { render, staticRenderFns } from "./PopoverSection.vue?vue&type=template&id=43c55e90&scoped=true"
import script from "./PopoverSection.vue?vue&type=script&lang=js"
export * from "./PopoverSection.vue?vue&type=script&lang=js"
import style0 from "./PopoverSection.vue?vue&type=style&index=0&id=43c55e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c55e90",
  null
  
)

export default component.exports